var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarOption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x37_20-_menu__x2C__ui__x2C__user_interface__x2C_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 13.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 105.643,
    y2: 105.643
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 13.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 256.511,
    y2: 256.511
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 13.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 407.312,
    y2: 407.312
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarOption);
export default __webpack_public_path__ + "static/media/NavbarOption.b37bb36d08c40a47d8406dfaf30adbb0.svg";
export { ForwardRef as ReactComponent };